module.exports = __webpack_public_path__ + "img/favicon.675be6b7.jpg";